export default "__VITE_ASSET__83ddaeea__"